import request from '@/utils/request'
// 营业额数据
// export const getTurnoverDataes = (data) =>
//   request({
//     'url': `/report/turnoverStatistics`,
//     'method': 'get',
//     data
//   })
// 首页数据
// // 今日数据
// export const getTodayDataes = () =>
//   request({
//     'url': `/workspace/todaydate`,
//     'method': 'get'
//   })
// 订单管理
export const getOrderData = () => {
  console.log('调用订单管理数据API')
  return request({
    'url': `/admin/workspace/overviewOrders`,
    'method': 'get'
  }).then(response => {
    console.log('订单管理API返回数据:', response)
    return response
  }).catch(error => {
    console.error('订单管理API错误:', error)
    throw error
  })
}
// 商品总览
export const getOverviewDishes = () => {
  console.log('调用商品总览API')
  return request({
    'url': `/admin/workspace/overviewDishes`,
    'method': 'get'
  }).then(response => {
    console.log('商品总览API返回数据:', response)
    return response
  }).catch(error => {
    console.error('商品总览API错误:', error)
    throw error
  })
}
// 抽奖总览
export const getDrawStatistics = () => {
  console.log('调用抽奖总览API')
  return request({
    'url': `/admin/workspace/overviewDraw`,
    'method': 'get'
  }).then(response => {
    console.log('抽奖总览API返回数据:', response)
    return response
  }).catch(error => {
    console.error('抽奖总览API错误:', error)
    throw error
  })
}
// 营业数据
export const getBusinessData= () => {
  console.log('调用营业数据API')
  return request({
    'url': `/admin/workspace/businessData`,
    'method': 'get'
  }).then(response => {
    console.log('营业数据API返回数据:', response)
    return response
  }).catch(error => {
    console.error('营业数据API错误:', error)
    throw error
  })
}
/**
 *
 * 报表数据
 *
 **/
// 统计
// 获取当日销售数据 -> 顶部数据
// export const getDataes = (params: any) =>
//   request({
//     'url': `/report/amountCollect/${params.date}`,
//     'method': 'get'
//   })

// 统一数据统计接口
export const getStatisticsData = (params: any) =>
  request({
    'url': `/admin/report/statisticsData`,
    'method': 'get',
    params
  })

// 营业额统计
export const getTurnoverStatistics= (params: any) =>
  request({
    'url': `/admin/report/turnoverStatistics`,
    'method': 'get',
    params
  })

// 用户统计
export const getUserStatistics= (params: any) =>
  request({
    'url': `/admin/report/userStatistics`,
    'method': 'get',
    params
  })
  // 订单统计
export const getOrderStatistics= (params: any) =>
request({
  'url': `/admin/report/ordersStatistics`,
  'method': 'get',
  params
})
  // 销量排名TOP10
  export const getTop= (params: any) =>
  request({
    'url': `/admin/report/top10`,
    'method': 'get',
    params
  })
  // 数据概览
  export const getDataOverView= (params: any) =>
  request({
    'url': `/admin/report/dataOverView`,
    'method': 'get',
    params
  })
  // 导出
  export function exportInfor() {
    return request({
      url: '/admin/report/export',
      method: 'get',
      responseType: "blob"
    })
  }

/**
 *
 * PC端价格上浮配置
 *
 **/
// 查询当前启用的PC端价格上浮配置
export const getPcPriceMarkupActive = () => {
  return request({
    url: '/admin/pc-price-markup/active',
    method: 'get'
  })
}

// 更新PC端价格上浮配置
export const updatePcPriceMarkup = (params: any) => {
  return request({
    url: '/admin/pc-price-markup',
    method: 'put',
    data: { ...params }
  })
}
